$(function () {
    // stick
    if ($(".sidebar").length) {
        var sidebar = new StickySidebar(".sidebar", {
            topSpacing: 200,
            containerSelector: ".wrapper__article-detail",
            innerWrapperSelector: ".sidebar__inner",
        });

        // unstick
        if ($(".wrapper__other-news").length) {
            var hT = $(".wrapper__other-news").offset().top,
                hH = $(".wrapper__other-news").outerHeight(),
                wH = $(window).height(),
                wS = $(this).scrollTop();
            if (wS + 200 > hT + hH - wH) {
                $(".sidebar").unstick();
            } else {
                $(".sidebar").sticky({
                    topSpacing: 80,
                    bottomSpacing: 0,
                });
            }
        }
    }

    //parallax
    let imgprlx = $(".wrapper__parallax-show"),
        hnav = $(".navbar__bottom").outerHeight();

    $(window).on('scroll', function () {
        var a = $(window).scrollTop(),
            b = hnav;
        a >= b ? (
                imgprlx.css({
                    "transform": "translateY(61px)"
                })) :
            (imgprlx.css({
                "transform": ""
            }))
    })

    // back to top
    $(".wrapper__back-to-top").on("click", function () {
        $("html, body").animate({ scrollTop: 0 }, 500);
        return false;
    });
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 175) {
            $(".wrapper__back-to-top").fadeIn("slow");
            $(".wrapper__share-btn").fadeIn("slow");
        } else {
            $(".wrapper__back-to-top").fadeOut("slow");
            $(".wrapper__share-btn").fadeOut("slow");
        }
    });

    // tooltip
    $('[data-toggle="popover"]').popover();
});
